module.exports = __webpack_public_path__ + "static/img/5.cb0d9e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/su/5.jpg
// module id = cVm8
// module chunks = 1